import type { ComponentType } from "react"
import { createRoot } from "react-dom/client"

import { createInertiaApp, router } from "@inertiajs/react"
import { toast } from "sonner"

import { Toaster } from "@/components/ui/sonner"

router.on("flash", (event) => {
  const { notice, alert } = event.detail.flash
  if (notice) toast.info(notice as string)
  if (alert) toast.error(alert as string)
})

const pages = import.meta.glob<{ default: ComponentType<unknown> }>("../pages/**/*.tsx")

createInertiaApp({
  resolve: async (name: string) => {
    const importPage = pages[`../pages/${name}.tsx`]
    if (!importPage) throw new Error(`Page not found: ${name}`)
    return importPage()
  },
  setup({ el, App, props }) {
    createRoot(el!).render(
      <>
        <App {...props} />
        <Toaster />
      </>,
    )
  },
  defaults: {
    future: {
      useScriptElementForInitialPage: true,
    },
  },
})
